<template>
  <nav id="nav" class="nav">
    <ul class="nav__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="{ 'nav-item--active': item.active }"
        class="nav-item"
      >
        <div class="nav-item__header">
          <span class="nav-item__title" v-text="item.title" />
          <span class="nav-item__subtitle" v-text="item.description" />
        </div>

        <!-- dropdown -->
        <this-dropdown v-if="item.dropdown" v-bind="item.dropdown" />
      </li>
    </ul>
  </nav>
</template>

<script>
import ThisDropdown from "./dropdown";

export default {
  name: "HeaderNav",

  components: {
    ThisDropdown
  },

  data() {
    return {
      items: [
        {
          title: "MAC",
          description: "Modern Air Combat",
          active: true,
          dropdown: {
            menu: [
              {
                title: "Game options",
                icon: "cog",
                link: "#"
              },
              {
                title: "Encyclopedia",
                icon: "book",
                link: "#"
              },
              {
                title: "Shop",
                icon: "shop",
                link: "#"
              },
              {
                title: "Exit",
                icon: "signout",
                link: "#"
              }
            ]
          }
        },
        {
          title: "FL",
          description: "Flying Legend",
          dropdown: {
            info: "Lorem Ipsum is simply dummy text of the printing",
            link: {
              text: "Buy Game",
              to: "#"
            }
          }
        },
        {
          title: "DCS",
          description: "Digital Combat Simulator",
          dropdown: {
            info: "Lorem Ipsum is simply dummy text of the printing",
            link: {
              text: "Run Game",
              to: "#"
            }
          }
        }
      ]
    };
  }
};
</script>

<style>
@import "./nav.css";
</style>
